module.exports = __webpack_public_path__ + "img/calendar-5.dafe9e94.svg";